export const DATE_FORMAT = "YYYY-MM-DD";
export const DATE_NUMBER_FORMAT = "YYYYMMDD";
export const DATE_FORMAT_GUI = "YYYY/MM/DD";
export const DATE_TIME_FORMAT_GUI = "YYYY/MM/DD HH:mm:ss";
export const DATE_MONTH_FORMAT = "YYYY-MM";
export const INTERVALS = [
    "1D",
    "1W",
    "1M",
    "1Y"
];
